import React from 'react';
import { GithubIcon, LinkedinIcon, TwitterIcon, MailIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="home" className="pt-28 pb-20 md:pt-32 md:pb-24 px-4" data-id="element-156">
      <div className="container mx-auto max-w-5xl flex flex-col md:flex-row items-center" data-id="element-157">
        <motion.div className="md:w-1/2 mb-10 md:mb-0" initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-158">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-159">
            Hi, I'm <span className="text-purple-600" data-id="element-160">ADIATU Habeeb</span>
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-600 mb-6" data-id="element-161">
            Network & Cybersecurity Specialist
          </h2>
          <p className="text-gray-600 mb-8 max-w-md" data-id="element-162">
            I specialize in networking, cybersecurity, operating systems, and PC
            troubleshooting to deliver secure and reliable technology solutions.
          </p>
          <div className="flex space-x-4" data-id="element-163">
            <motion.a href="#contact" className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-md font-medium transition duration-300" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-164">
              Contact Me
            </motion.a>
            <motion.a href="#projects" className="border border-gray-300 hover:border-purple-400 text-gray-700 px-6 py-3 rounded-md font-medium transition duration-300" whileHover={{
            scale: 1.05,
            borderColor: '#9333ea'
          }} whileTap={{
            scale: 0.95
          }} data-id="element-165">
              View Work
            </motion.a>
          </div>
          <div className="flex mt-8 space-x-4" data-id="element-166">
            <motion.a href="#" className="text-gray-600 hover:text-purple-600" aria-label="GitHub" whileHover={{
            scale: 1.2,
            color: '#9333ea'
          }} data-id="element-167">
              <GithubIcon size={24} data-id="element-168" />
            </motion.a>
            <motion.a href="#" className="text-gray-600 hover:text-purple-600" aria-label="LinkedIn" whileHover={{
            scale: 1.2,
            color: '#9333ea'
          }} data-id="element-169">
              <LinkedinIcon size={24} data-id="element-170" />
            </motion.a>
            <motion.a href="#" className="text-gray-600 hover:text-purple-600" aria-label="Twitter" whileHover={{
            scale: 1.2,
            color: '#9333ea'
          }} data-id="element-171">
              <TwitterIcon size={24} data-id="element-172" />
            </motion.a>
            <motion.a href="#" className="text-gray-600 hover:text-purple-600" aria-label="Email" whileHover={{
            scale: 1.2,
            color: '#9333ea'
          }} data-id="element-173">
              <MailIcon size={24} data-id="element-174" />
            </motion.a>
          </div>
        </motion.div>
        <motion.div className="md:w-1/2 flex justify-center" initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-175">
          <motion.div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-purple-200" whileHover={{
          scale: 1.05,
          borderColor: '#9333ea'
        }} transition={{
          duration: 0.3
        }} data-id="element-176">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s3momGbLvH3tnoqkxuuXAQ/WhatsApp_Image_2025-08-08_at_12.42.25_213fd18a.jpg" alt="ADIATU Habeeb in professional attire" className="w-full h-full object-cover" data-id="element-177" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}